<template>
  <div>
    <ts-dialog
      title="Add selected files to my project"
      :visible.sync="visible"
      width="850px"
      center
      :show-close="false"
    >
      <div class="filter-bar">
        <ts-search-bar size="mini" placeholder="Search a file" :value="query" @input="handleQueryChange">
        </ts-search-bar>
      </div>
      <div class="list">
        <div v-for="asset in assets" :key="asset.id" class="row">
          <ts-checkbox
            class="checkbox"
            :value="isAssetSelected(asset)"
            @input="handleAssetCheck(asset, $event)"
          ></ts-checkbox>
          <div class="thumbnail">
            <Thumbnail v-if="asset.file && asset.file.thumbnail" :url="asset.file.thumbnail" />
          </div>
          <div class="file-info">
            <p class="file-name">{{ asset.name }}</p>
            <p class="file-creation-info">Created on {{ formatDate(asset.createdAt) }} by {{ asset.createdBy.name }}</p>
          </div>
          <div class="actions">
            <ts-button size="small" circle @click="handleDownloadAssetClick(asset)">
              <ts-icon icon="save" size="x-small" color="#6d7587" />
            </ts-button>
            <ts-button size="small" circle>
              <ts-icon icon="eye" size="x-small" color="#6d7587" />
            </ts-button>
          </div>
        </div>
      </div>
      <span slot="footer">
        <div class="footer">
          <ts-button size="small" @click="handleUploadClick">
            Upload selected files ({{ selectedAssets.length }})</ts-button
          >
        </div>
      </span>
    </ts-dialog>
    <ts-button size="small" @click="handleOpenPickerButtonClick">
      Load from project
    </ts-button>
  </div>
</template>

<style lang="scss" scoped>
.filter-bar {
  margin: 0 110px 30px 110px;
}

.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 12px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .thumbnail {
    width: 48px;
    margin-right: 12px;
  }

  .file-info {
    flex-grow: 1;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}

.footer {
  padding-top: 12px;
}
</style>

<script>
import { debounce } from 'lodash';

import { listAssets } from '@/api/workflow';

import Thumbnail from '@/components/Thumbnail.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  components: {
    Thumbnail
  },
  props: {
    projectId: {
      type: String,
      required: true
    },
    groups: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      query: '',
      assets: [],
      selectedAssets: []
    };
  },
  methods: {
    isAssetSelected(asset) {
      return !!this.selectedAssets.find(a => a.id === asset.id);
    },
    async refreshFileList(query) {
      this.assets = await listAssets({
        filters: {
          groups: this.groups,
          types: ['uploaded-file'],
          query
        }
      });
    },
    refreshFileListDebounced: debounce(function(query) {
      this.refreshFileList(query);
    }, 500),
    handleQueryChange(query) {
      this.query = query;
      this.refreshFileListDebounced(query);
    },
    handleOpenPickerButtonClick() {
      this.selected = {};
      this.visible = true;
    },
    handleAssetCheck(asset, value) {
      if (value) {
        this.selectedAssets = [...this.selectedAssets, asset];
      } else {
        this.selectedAssets = this.selectedAssets.filter(a => a.id !== asset.id);
      }
    },
    handleDownloadAssetClick(asset) {
      window.open(asset.file.url, '_blank');
    },
    handleUploadClick() {
      this.$emit('input', this.selectedAssets);
      this.visible = false;
    }
  }
};
</script>
